export default {
  namespaced: true,
  state: {
    showModal: {
      show: false,
      id: null,
      isTitle: false,
    },
  },
  getters: {
    getShow: (state) => state.showModal.show,
    getId: (state) => state.showModal.id,
    getIsTitle: (state) => state.showModal.isTitle,
  },
  mutations: {
    TOGGLE_MODAL(state, obj) {
      if (obj.show) {
        state.showModal.id = obj.id ? obj.id : null;
        state.showModal.isTitle = obj.isTitle ? obj.isTitle : false;
        //   state.showModal.type = obj.type ? obj.type : "";
        //   state.showModal.groupId = obj.groupId ? obj.groupId : null;
        //   state.showModal.copyTradeDetail = obj.copyDetail ? obj.copyDetail : {};
      }
      state.showModal.show = obj.show;
    },
  },
  actions: {
    toggleModal({ commit }, obj) {
      commit("TOGGLE_MODAL", obj);
    },
  },
};
